import { createTheme } from "@mui/material/styles";

const themev5 = createTheme({
  typography: {
    fontFamily: "Montserrat, Arial, sans-serif",
    htmlFontSize: 10,
    h1: { fontSize: "3.6rem", fontWeight: 700 },
    h2: { fontSize: "3.0rem", fontWeight: 700 },
    h3: { fontSize: "2.4rem", fontWeight: 700 },
    h4: { fontSize: "2.0rem", fontWeight: 700 },
    h5: { fontSize: "1.8rem", fontWeight: 700 },
    h6: { fontSize: "1.6rem", fontWeight: 700 },
    subtitle1: { fontSize: "1.6rem", fontWeight: 500 },
    subtitle2: { fontSize: "1.4rem", fontWeight: 500 },
    body1: { fontSize: "1.4rem", fontWeight: 400 },
    body2: { fontSize: "1.2rem", fontWeight: 400 },
    button: {
      fontSize: "1.4rem",
      fontWeight: 600,
      textTransform: "none" as const,
    },
    caption: { fontSize: "1.2rem", fontWeight: 400 },
    overline: { fontSize: "1rem", fontWeight: 400 },
  },
  shape: {
    borderRadius: 8,
  },
  palette: {
    primary: {
      main: "#D91F05",
    },
    common: {
      black: "#000000",
    },
    background: {
      paper: "#fff",
    },
    text: {
      primary: "#3E3D3D",
      secondary: "#9e9e9e",
      disabled: "#999999",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

export default themev5;
